import { styled } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  img {
    margin-top: ${({ theme }) => theme.spacing.xxxs};
    display: block;
  }
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 90%;
      margin: 0 auto;
    }
  `}
`;
